import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const TrashIcon = ({
  color = 'white',
  width = 12,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 14">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M11.319 2.83c.248 0 .449.223.449.5 0 .245-.16.45-.369.492l-.08.008h-.498c.002.03.004.06.004.09v8.869c0 .552-.448 1-1 1H1.943c-.552 0-1-.448-1-1v-8.87l.005-.09H.449C.201 3.83 0 3.607 0 3.33c0-.245.159-.449.368-.491L.45 2.83h10.87zM4.453 5.929c-.246 0-.45.159-.492.368l-.008.08v3.953l.008.081c.042.21.246.369.492.369.245 0 .45-.16.491-.369l.009-.08V6.377l-.009-.08c-.042-.21-.246-.37-.491-.37zm2.964 0c-.246 0-.45.159-.492.368l-.008.08v3.953l.008.081c.042.21.246.369.492.369.245 0 .45-.16.492-.369l.008-.08V6.377l-.008-.08c-.042-.21-.247-.37-.492-.37zM8.354 0c.248 0 .45.224.45.5 0 .245-.16.45-.37.492L8.355 1h-4.94c-.249 0-.45-.224-.45-.5 0-.245.16-.45.369-.492L3.413 0h4.941z"
      />
    </svg>
  </DefaultIconWrapper>
);
